export default __webpack_public_path__ + "static/3-control-panel-485cbcdc01734a8b908b69770311811e.jpg";